import { useState, useEffect } from "react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Our Paths", href: "#paths" },
  { label: "Benefits", href: "#benefits" },
  { label: "Your Journey", href: "#journey" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-20">
        <a
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick("#home");
          }}
          className="flex items-center cursor-pointer"
        >
          <img
            alt="Wellness & Freedom Logo"
            className="h-14 w-auto"
            src="https://trzebeky.gensparkspace.com/images/logo.png"
          />
        </a>

        <ul className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="text-sm font-medium text-olive-700 hover:text-olive-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="https://calendly.com/carol-berry305"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap bg-olive-500 hover:bg-olive-600 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors cursor-pointer inline-block"
            >
              Book a Free Call
            </a>
          </li>
        </ul>

        <button
          className="md:hidden text-olive-700 text-xl cursor-pointer w-10 h-10 flex items-center justify-center"
          aria-label="Toggle Menu"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className="fas fa-bars"></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-olive-100 px-4 py-4 shadow-lg">
          <ul className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(link.href);
                  }}
                  className="block text-sm font-medium text-olive-700 hover:text-olive-500 transition-colors cursor-pointer py-2"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="https://calendly.com/carol-berry305"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap bg-olive-500 hover:bg-olive-600 text-white text-sm font-semibold px-5 py-2 rounded-full transition-colors cursor-pointer inline-block text-center"
              >
                Book a Free Call
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}